import { createUseStyles } from '@glu/theming';

const styles = ({ formComponents }) => ({
  root: {
    fontSize: 12,
    margin: [6, 0, 0],
    padding: 0,
    ...formComponents.helpText
  }
});

export default createUseStyles(styles);
